export default __webpack_public_path__ + "static/media/character zoi.c136cc5a.svg";